export default {
    manufacturer_create_success_message: "The manufacturer has been created",
    manufacturer_create_title: "Create Manufacturer",
    manufacturer_edit_success_message: "The manufacturer has been edited",
    manufacturer_edit_title: "Edit Manufacturer",
    manufacturer_name: "Name",
    manufacturer_status: "Status",
    manufacturer_active: "Active",
    manufacturer_inactive: "Inactive",
}